import { useQuery } from "react-query";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";
import { getConsentHeaders } from "./consentHeaders";

export const getConsentGateItemsKey = "getConsentGateItems" as const;

const ConsentGateItemSchema = z.object({
    itemId: z.number(),
    versionId: z.number(),
    code: z.string(),
    name: z.string(),
    description: z.string().nullable().optional(),
    category: z.string().nullable().optional(),
    version: z.string(),
    title: z.string(),
    summary: z.string().nullable().optional(),
    content: z.string().nullable().optional(),
    documentUrl: z.string().nullable().optional(),
});

export type ConsentGateItem = z.infer<typeof ConsentGateItemSchema>;

type Options = {
    enabled?: boolean;
};

export const useGetConsentGateItems = (options?: Options) => {
    const { enabled = true } = options ?? {};

    const query = useQuery({
        queryKey: [getConsentGateItemsKey],
        enabled,
        queryFn: async () => {
            const response = await loggedInApiCall.get("/api/users/me/consent-gate/items", {
                headers: getConsentHeaders(),
            });

            return response;
        },
        select: (response) => {
            const items = response.data["hydra:member"] ?? [];

            return zodParseWithDetailedLog(items, ConsentGateItemSchema.array(), {
                operation: "GET",
                endpoint: "/users/me/consent-gate/items",
            });
        },
    });

    return {
        consentGateItems: query.data,
        ...query,
    };
};
